module.exports = __webpack_public_path__ + "img/menu_plan.64dae850.svg";